import Lenis from "lenis";

export function initSmoothScroll() {
  const lenis = new Lenis();

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  window.lenis = lenis; // Expose lenis instance to the global scope for debugging or further use

  requestAnimationFrame(raf);
}
